export default __webpack_public_path__ + "static/media/vpTheft.684ca833.svg";